import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getClustersFlowList = async (page, pageSize) => {
  const builder = new UrlBuilder(`/admin/flows/list`);

  try {
    const response = await post(builder.toString(), { pageNumber: page, perPage: pageSize });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const createClusterFlow = async (payload) => {
  const builder = new UrlBuilder(`/admin/flows/create`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateClusterFlow = async (payload) => {
  const builder = new UrlBuilder(`/admin/flows/update`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const deleteClusterFlow = async (payload) => {
  const builder = new UrlBuilder(`/admin/flows/delete`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
